import styled from 'styled-components'
import { TextBody, MuiTheme } from '@ally/metronome-ui'

export const TextBodyOverride = styled(TextBody)<{
  color: keyof MuiTheme['colors']
}>`
  ${({ theme: { colors }, color }): string => `
    color: ${colors[color]};
  `}
`
